import Vue from 'vue';
import Vuex from 'vuex';
import {DateTime} from 'luxon';
import VuexPersistence from 'vuex-persist';
import {CALCULATION_MODE} from "./constants";

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage
})

export default new Vuex.Store({
  state: {
      authToken: null,

      performance: {},
      investments: {},
      calculation: {
        kontensicht: {},
        settings: {}
      },
      buffer: {},
      tarifierung: {
        'single': null,
        'rate': null
      },
      appmode: {
        single: 'buffer',
        rate: 'buffer'
      },              // Angezeigte Daten kommen vom Server 'buffer', 'custom-values', 'custom-calculation'
      mode : CALCULATION_MODE['single'], // or FIXE
      menu: {}
  },
  getters: {
     authToken: state => {
        return state.authToken;
     },
     performanceData: state => {
        return state.performance.data;
        },
     performanceTitle: state => {
        return state.performance.title
        },
     investmentsData: state => {
        return state.investments.data;
        },
     investmentsTitle: state => {
        return state.investments.title;
      },
      getMode: state=> {
          return state.mode
      },
      getAppMode: state=> {
        return state.appmode[state.mode];
      },
     calculation: state => {
        return state.calculation;
        },
      iposnummer: state => {
        return state.tarifierung.iposnummer
      },
      servermessage: state => {
        return state.tarifierung.messageList || null;
      },
      servererror: state => {
        return state.tarifierung.errorMessage || null;
      },
      menu: state => {
        return state.menu;
      },

      getXAxisIndex: state => {
          if (state.calculation.kontensicht[state.mode]) {
            return state.calculation.kontensicht[state.mode].columnIndex.indexOf( "VERTRAGSMONAT" );
          }

          if (state.buffer.kontensicht[state.mode]) {
              return state.buffer.kontensicht[state.mode].columnIndex.indexOf( "VERTRAGSMONAT" ) ;
          }
          return {}

      },
      getValueIndex: state => {

        if (state.calculation.kontensicht[state.mode]) {
            return state.calculation.kontensicht[state.mode].columnIndex.indexOf( "VERTRAGSWERT_GESAMT" );
        }
        return state.buffer.kontensicht[state.mode].columnIndex.indexOf( "VERTRAGSWERT_GESAMT");
      },
      getDataRows: state => {
        if (state.appmode[state.mode] === "custom-values") return {}
        if (state.calculation.kontensicht[state.mode]) {
            return state.calculation.kontensicht[state.mode].dataRows;
        }
        return state.buffer.kontensicht[state.mode].dataRows;
      },
      dateOfPension: state => {

         let milestones = null;

          if (state.calculation.kontensicht[state.mode]) {
               milestones = state.calculation.kontensicht[state.mode].milestones;
          }

          if (state.buffer.kontensicht[state.mode]) {
              milestones = state.buffer.kontensicht[state.mode].milestones;
          }
          if (milestones !== null) {
                let rentenbeginn = milestones.find(milestone => milestone.text === "Rentenbeginn");
                if (rentenbeginn) {
                  return rentenbeginn.data;
                }
          }
          return null;

      },
      getCalculationDOB: state => {
          const today = DateTime.local();
          return today.minus({years: state.buffer.settings.age});
      },
      getCalculationDate: state => {
          if (state.calculation.settings.date_from) {
            return state.calculation.settings.date_from;
          }

          return state.buffer.settings.date_from;
      },

      getAmount: state => {
         if (state.calculation.settings[state.mode]) {
            return state.calculation.settings[state.mode]
         }
          return state.buffer.settings[state.mode];
      },
      interestRate: state => {
          if (state.calculation.settings.interest) {
              return state.calculation.settings.interest
          }
          return state.buffer.settings.interest;
      }
  },
  actions: {
     addAuthToken: ({commit}, token) => {
        commit('setAuthToken', token);
     },
     addPerformanceData: ({commit}, data) => {
        commit('setPerformance', data);
     },
     addInvestmentsData: ({commit}, data) => {
        commit('setInvestments', data);
     },
     addCalculationData: ({commit}, data) => {
        commit('setCalculation', data);
     },
     addTarifierungsResult: ({commit}, data ) => {
        commit('setTarifierungsResult', data);
     },
     addCustomCalculation: ({commit}, data) => {
        commit('setCustomCalculation', data);
     },
     addMenu: ({commit}, data) => {
        commit('setMenu', data);
      },
      addBufferData: ({commit}, data) => {
        commit('addBuffer', data);
      },
      setMode: ({commit}, mode) => {
        commit('setMode', mode);
      },
      setAppMode: ({commit}, appmode) => {
        commit('setAppMode',appmode);
      },
      setDate: ({commit}, date) => {
          commit('setDate', date);
      },
      setInterest: ({commit}, interest) => {
          commit('setInterest', interest);
      },
      setAmount: ({commit}, amount) => {
          commit('setAmount', amount);
      },
      deleteCustomCalculation: ({commit}) => {
         commit('deleteCustomCalculation');
      }
  },
  mutations: {
     setAuthToken: (state, token) => {
        state.authToken = token;
     },
     setPerformance: (state, data) => {
        state.performance = data;
     },
     setInvestments: (state, data) => {
        state.investments = data;
  },
     setCalculation: (state, data) => {
        state.calculation.kontensicht = data;
     },
     setTarifierungsResult: (state, data) => {
        state.tarifierung = data;
     },
     setCustomCalculation: (state, data) => {
        state.calculation.kontensicht[state.mode] = data;
     },
     setMenu: (state, data) => {
        state.menu = data;
     },
     addBuffer: (state, data) => {
        state.buffer = data;
     },
     setMode: (state, mode) => {
        state.mode = mode;
     },
     setAppMode: (state, appmode) => {
        state.appmode[state.mode] = appmode;
     },
     setDate: (state, date) => {
        Vue.set(state.calculation.settings, 'date_from', date)  // Reactivity gilt nicht für Arrays.
     },
     setAmount: (state, amount) => {
        Vue.set(state.calculation.settings, state.mode, amount)
     },
     setInterest: (state, rate) => {
        Vue.set(state.calculation.settings, 'interest', rate);
     },
     deleteCustomCalculation: (state) => {
        state.calculation = {
            kontensicht: {},
            settings :{}
        }
     }
  },
  plugins: [vuexLocal.plugin]
})
